module.exports = __webpack_public_path__ + "static/media/skater3.6cd3ec21.jpg";